import { createContext } from 'react'

const GridCarouselContext = createContext(false)

export default GridCarouselContext
